// @flow

import React, { useState, useEffect, useCallback } from 'react'
import classNames from 'classnames'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import Button from '../basic/Button'
import baseStyles from './VideoCookiesWrapper.scss'
import messages from './VideoCookiesWrapper.lang'

type Props = {
  children: any,
  ...StyleProps
}

const VideoCookiesWrapper = ({ styles, children }: Props) => {
  const { formatMessage } = useIntl()

  const [shouldBlockYoutube, setShouldBlockYoutube] = useState(true)

  const checkConsent = useCallback(() => {
    if (global.window && window.cookiehub) {
      if (window.cookiehub.hasConsented("marketing")) {
        setShouldBlockYoutube(false)
      } else {
        setShouldBlockYoutube(true)
      }
    }
  }, [])

  const openCH = useCallback(() => {
    if (global.window && window.cookiehub) {
      window.cookiehub.openSettings()
    }
  }, [])

  useEffect(() => {
    window.addEventListener('cookieHubInitialised', checkConsent)

    return () => {
      window.removeEventListener('cookieHubInitialised', checkConsent)
    }
  }, [])

  return (
    <div className={styles.root}>
      {shouldBlockYoutube ? (
        <>
          <div className={styles.consentOverlay}>
            <span className={classNames(styles.consentOverlayIcon, 'icon-youtube')} title="Youtube icon" />
            <p>{formatMessage(messages.cookieConsentText)}</p>
            <Button className={styles.cookieSettingsBtn} color="primary" onClick={openCH}>
              <span>{formatMessage(messages.cookieConsentButton)}</span>
            </Button>
          </div>
        </>
      ) : (
        children
      )}
    </div>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(VideoCookiesWrapper)
